import { IApplicationState } from '../../types/redux';
import { IVideo } from '../../types/video';

export function getVideos(state: IApplicationState): IVideo[] {
  return state.newbuilding.videos;
}
